<template>
  <svg
    width="26"
    height="18"
    viewBox="0 0 26 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.0883 6.83333H20.5833C23.5744 6.83333 26 9.25783 26 12.25C26 15.2422 23.5744 17.6667 20.5833 17.6667C17.5923 17.6667 15.1667 15.2422 15.1667 12.25C15.1667 11.0247 15.5892 9.90783 16.2738 8.99999L14.0833 9.00324C14.0833 11.0551 12.6523 12.7657 10.7358 13.2142C10.7358 13.2163 10.7348 13.2196 10.7337 13.2207C10.4195 13.2943 10.0902 13.3333 9.75325 13.3333H8.46625H4.875C4.576 13.3333 4.33333 13.0939 4.33333 12.7949V11.7116C4.33333 11.4126 4.576 11.1699 4.875 11.1699H8.46733C8.01992 9.90999 6.82825 8.99999 5.41667 8.99999C3.62483 8.99999 2.16667 10.4582 2.16667 12.25C2.16667 14.0418 3.62483 15.5 5.41667 15.5C6.37108 15.5 7.21933 15.0764 7.80975 14.4167H10.3513C9.51492 16.3244 7.63317 17.6667 5.41667 17.6667C2.42558 17.6667 0 15.2422 0 12.25C0 9.25783 2.42558 6.83333 5.41667 6.83333H16.6649L14.8038 3.10666C14.6185 2.73508 14.2383 2.49999 13.8233 2.49999H11.375C11.076 2.49999 10.8333 2.25733 10.8333 1.95833V0.874995C10.8333 0.575995 11.076 0.333328 11.375 0.333328H13.8277C15.0594 0.333328 16.1861 1.02991 16.7375 2.13166L19.0883 6.83333ZM17.3333 12.25C17.3333 14.0418 18.7915 15.5 20.5833 15.5C22.3752 15.5 23.8333 14.0418 23.8333 12.25C23.8333 10.4582 22.3752 8.99999 20.5833 8.99999C20.4752 8.99999 20.3712 9.01475 20.2669 9.02954C20.2417 9.03312 20.2165 9.0367 20.1912 9.04008L21.6959 12.0474C21.7544 12.1655 21.7479 12.3052 21.6797 12.4168C21.6103 12.5295 21.4879 12.5967 21.3568 12.5967H20.046C19.7383 12.5967 19.4567 12.4222 19.3191 12.1471L18.2466 10.001C17.6843 10.5849 17.3333 11.3757 17.3333 12.25Z"
      :fill="completed ? 'white' : '#87929D'"
    />
  </svg>
</template>

<script>
export default {
  props: ["completed"]
};
</script>
